import React from "react";
import InfoAlert from "../elements/InfoAlert";
import AlertItem from "../elements/AlertItem";

const Authors = () => {
  return (
    <>
      <div className="col-12">
        <InfoAlert title="Authors :" isToggled>
          <AlertItem>
            Ali A. Asadi-Pooya, M.D.<sup>1,2</sup>
          </AlertItem>
          <AlertItem>
            Arashk Mallahzadeh<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Maryam Koochaki<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Erfan Taherifard<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Ehsan Taherifard<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Mahdi Malekpour<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Kasra Assadian<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Niloofar Dehdari Ebrahimi<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Nafiseh Mirzaei Damabi, Ph.D.<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Ali Sioofi<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Ali Ansari<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Alireza Shaabanpour<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Alireza Ahmadkhani<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Khatereh Fazelian dehkordi, Ph.D.<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Reza Moshfeghinia<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Tahereh Fereydoonnezhad<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Kiarash Kavari<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Dorsa Shekouh<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Seyed Ali Mansouri<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Kamyab Shahrivar<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Sarvin Sasannia<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Sanam Faizabadi<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Mana Moghadami<sup>1</sup>
          </AlertItem>
          <AlertItem>
            Nahid Abolpour, Ph.D.<sup>1</sup>
          </AlertItem>
          <div className="body-item mt sp">
            <p>
              <span className="circle-symbol">1. </span>
              Epilepsy Research Center, Shiraz University of Medical Sciences,
              Shiraz, Fars, Iran.
            </p>
          </div>
          <div className="body-item sp">
            <p>
              <span className="circle-symbol">2. </span>
              Jefferson Comprehensive Epilepsy Center, Department of Neurology,
              Thomas Jefferson University, Philadelphia, PA, USA
            </p>
          </div>
        </InfoAlert>
      </div>
    </>
  );
};

export default Authors;
